import React from "react";
import { useNavigate } from "react-router-dom";
import { SearchBarWr} from "../../../_uiComponents/common/form/UiInputComponents";
import LookUpTableFilterForm from "./forms/LookupTableFilterForm";
import { MainLeftTitle, CreateButton } from '../../../_uiComponents/WrapperComponents'
import LookupTableManagement from "./LookupTableManagement";
import { UiAccordian } from "../../../_uiComponents/common/form/UiToggleArea";


export const LookupTableWrapper = () => {
    const navigate = useNavigate();
    const handleData = () => {
        let path = `/ui/create-lookup-table`;
        navigate(path);
    }

    return (

        <>
       
            <div className='sbt-data-grid__wr'>
                <MainLeftTitle title="Lookup Table Management">
                    <CreateButton name="Create lookup table" onClick={handleData} />
                </MainLeftTitle>
                <UiAccordian>
                    <SearchBarWr>
                        <LookUpTableFilterForm />
                    </SearchBarWr>
                </UiAccordian>

                <LookupTableManagement />
            </div>
        </>
    )

}